"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextInput;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function TextInput({
  control,
  errors,
  field,
  label
}) {
  const hasError = Boolean(errors) && Boolean(errors[field]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    defaultValue: "",
    render: ({
      field: fields
    }) => {
      return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, hasError ? {
        error: true
      } : {}, fields, {
        id: field,
        label: label,
        variant: "outlined",
        helperText: hasError ? errors[field].message : ''
      }));
    }
  }));
}